import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Standard eForms Questions',
		url: '/standard_eForms_questions',
		icon: 'archive',
	},
];

class StandardNfaQuestion extends Framework.Components.View {
	constructor(props) {
		super(props, 'details');
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

					<Objects.Standard_Nfa_Questions
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						id={this.props.rootState.account_number}
					/>
			</div>
		)
	}
};



export default Framework.Components.withRootState(StandardNfaQuestion);